<template>
  <div class="league-admin section">

    <div class="level">
      <div class="level-left">
        <h1 class="title">Leagues</h1>
      </div>
      <div class="level-right">
        <league-add></league-add>
      </div>
    </div>

    <div class="leagues">
      <div class="media level" v-for="league in leagues">
        <a v-link="{ path: '/leagues/' + league.key }">
          <h2 class="subtitle">
            {{ league.en.title }}
            {{league.en.subtitle}}
          </h2>
        </a>
        <a v-link="{ path: '/leagues/' + league.key + '/edit' }" class="button">
          Edit
        </a>
        <button @click="deleteLeague(league)" class="button is-danger">Delete</button>
      </li>
    </div>

  </div>
</template>

<script>
  import fb from 'firebase'
  import LeagueAdd from './LeagueAdd.vue'

  export default {
    components: {
      LeagueAdd
    },
    data: function() {
      return {
        leagues: []
      }
    },
    ready: function() {
      var self = this
      fb.database().ref('leagues').on('child_added', function(snapshot) {
        var league = snapshot.val()
        league.key = snapshot.key
        self.leagues.push(league)
      })
    },
    methods: {
      deleteLeague: function(league) {
        fb.database().ref('leagues/' + league.key).set(null)
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** LeagueAdmin.vue?3a45372e
 **/